var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 95,
    width: 142,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#c7c8d7",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.045 25.898l-8.91 8.91M123.5 44.5h-9m3.15 14.472l-2.606-2.607M83 24.322l2.606 2.606M96.5 18.5v9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25,
    rx: 4.5,
    width: 78,
    x: 3.5,
    y: 59.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25,
    rx: 4.5,
    width: 63,
    x: 35.5,
    y: 40.5
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9Ijk1IiB3aWR0aD0iMTQyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0iI2M3YzhkNyIgc3Ryb2tlLXdpZHRoPSIzIj48cGF0aCBkPSJtMTE1LjA0NSAyNS44OTgtOC45MSA4LjkxbTE3LjM2NSA5LjY5MmgtOW0zLjE1IDE0LjQ3Mi0yLjYwNi0yLjYwN20tMzIuMDQ0LTMyLjA0MyAyLjYwNiAyLjYwNm0xMC44OTQtOC40Mjh2OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PHJlY3QgaGVpZ2h0PSIyNSIgcng9IjQuNSIgd2lkdGg9Ijc4IiB4PSIzLjUiIHk9IjU5LjUiLz48cmVjdCBoZWlnaHQ9IjI1IiByeD0iNC41IiB3aWR0aD0iNjMiIHg9IjM1LjUiIHk9IjQwLjUiLz48L2c+PC9zdmc+";
export { SvgIconEmptyCalendar as ReactComponent };